import script from "./ExtratoController.vue?vue&type=script&setup=true&lang=js"
export * from "./ExtratoController.vue?vue&type=script&setup=true&lang=js"

import "./ExtratoController.vue?vue&type=style&index=0&id=c14b4754&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c14b4754"]])

export default __exports__